// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_THEME_CONTEXT_VALUE = {
  theme: "light",
  cycleTheme: function cycleTheme() {
    return undefined;
  }
};